import styled from 'styled-components';

export const FormStyle = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  .delete-btn {
    min-width: 20px;
    margin-top: 30px;
  }
  .inputs {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    button {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #7888f5;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const StyledWrapper = styled.form`
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .elements {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    .input {
      label {
        color: #25262b;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        display: block;
        margin-bottom: 4px;
      }
      input {
        padding: 8px 12px;
        border-radius: 4px;
        border: 1px solid #ced4da;
        outline: none;
        width: 100%;
      }
    }
    .switch {
      display: flex;
      align-items: center;
      gap: 12px;
      align-items: flex-end;
      label {
        color: #101113;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }

  .search-bar {
    margin-top: 24px;
    .top-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      .title {
        color: #25262b;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
      }
      .expand {
        display: flex;
        align-items: center;
        gap: 8px;
        p {
          color: #101113;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
  }

  .periods {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    .element {
      label {
        color: #25262b;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        display: block;
        margin-bottom: 4px;
      }
    }
  }

  .funds-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .funds {
      .header {
        border-radius: 8px 8px 0px 0px;
        background: #f8f9fa;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 12px;
        p {
          color: #495057;
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
        }
      }
      .body {
        .switch {
          width: 50%;
          padding: 30px 12px;
          border-right: 1px solid #f1f3f5;
          border-bottom: 1px solid #f1f3f5;
          border-left: 1px solid #f1f3f5;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .fund-name {
          display: flex;
          .name {
            min-width: 50%;
            max-width: 50%;
            padding: 30px 12px;
            border-bottom: 1px solid #f1f3f5;
            border-left: 1px solid #f1f3f5;
            color: #000;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
            display: flex;
            gap: 8px;
            align-items: center;
            svg {
              min-width: 16px;
              cursor: pointer;
              color: #c1c2c5;
            }
          }
        }
        .period {
          display: flex;
          p {
            padding: 28px 12px 28px 56px;
            color: #000;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            border-bottom: 1px solid #f1f3f5;
            border-left: 1px solid #f1f3f5;
            min-width: 50%;
            max-width: 50%;
          }
        }
      }
    }
  }

  .buttons {
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: flex-end;
    margin-top: 40px;
    .merge-all {
      display: flex;
      align-items: center;
      color: #101113;
      font-size: 14px;
      line-height: 20px;
      gap: 4px;
    }
  }
`;
